<ng-container>
	<mat-form-field floatLabel="always">
		<mat-label>{{ label }}</mat-label>
		<input matInput localizedNumericInput [digitsInfo]="digitsInfo"
			type="text" [formControlName]="formControlName" inputmode="numeric" pattern="^\d+(\.\d+)?$"
		/>
		<span *ngIf="prefix" matPrefix>{{ prefix }}</span>
	</mat-form-field>
</ng-container>